import { Button } from "@/components/ui/button";
import { CardContent } from "@/components/ui/card";
import { Card } from "@/components/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { XIcon } from "lucide-react";
import React, { JSX } from "react";

interface FilterCardProps {
  label: string;
  content: React.ReactNode;
  onRemove: () => void;
}

/**
 * FilterCard component
 * Displays an active filter as a card with a tooltip showing the filter label
 *
 * @param {Object} props - Component props
 * @param {string} props.label - The label text to display in the tooltip
 * @param {React.ReactNode} props.content - The content to display inside the card
 * @param {Function} props.onRemove - Callback function when the remove button is clicked
 * @returns {JSX.Element} FilterCard component
 */
const FilterCard = ({
  label,
  content,
  onRemove
}: FilterCardProps): JSX.Element => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Card className="bg-white border border-slate-200 hover:bg-slate-50 cursor-default rounded-md">
          <CardContent className="p-2 flex items-center gap-2">
            {content}
            <Button
              variant="ghost"
              size="xs"
              className="h-5 w-5 p-0 ml-1"
              onClick={onRemove}
            >
              <XIcon className="h-3 w-3" />
            </Button>
          </CardContent>
        </Card>
      </TooltipTrigger>
      <TooltipContent side="top">
        <p className="text-xs">{label}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default FilterCard;
